import $ from 'jquery';
import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery.js';
import ExternalScriptLoader from 'sharedController/externalScriptLoader';

export default class USPBannerBar {
    init()
    {
        let me = this;

        $(document).ready(() => {
            me.loadTrustPilotScript();
            me.transition();
            $(window).on('changed.zf.mediaquery', function () {
                me.transition();
            });
        });
    }

    transition()
    {
        if (!this.module && ! MediaQuery.atLeast('large')) {
            import('./transition').then((Transition) => {
                this.module = new Transition.default('#uspBannerBar .cell.usp');
                this.module.init();
            });
        }
    }

    loadTrustPilotScript()
    {
        let me = this;
        let script =  'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
        if ($('.trustpilot-widget').attr('data-template-id')) {
            me.externalScriptLoader = new ExternalScriptLoader();
            me.externalScriptLoader.loaded(script);
        }
    }
}